import { AxiosInstance } from 'axios';

import { DboAPIApiFactory } from '@cast/openapi';
import {
  AdvisorAPIApiFactory,
  CachingAPIApiFactory,
  DatabaseInstancesAPIApiFactory,
  TelemetryAPIApiFactory,
} from '@cast/openapi-database-optimizer';

import { AXIOS_CONFIGURATION } from '../constants';

export const DboApiAdapter = (client: AxiosInstance) => {
  const v1Api = DboAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const v2AdvisorApi = AdvisorAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const v2CachingApi = CachingAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const v2DatabaseInstancesApi = DatabaseInstancesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const v2TelemetryApi = TelemetryAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  return {
    createCacheGroup: v1Api.dboAPICreateCacheGroup,
    createCachingRule: v1Api.dboAPICreateCacheTTL,
    createRegistration: v1Api.dboAPICreateRegistration,
    getRegistrationStatus: v1Api.dboAPIGetRegistrationStatus,
    createCacheConfiguration: v1Api.dboAPICreateCacheConfiguration,
    deleteCachingRule: v1Api.dboAPIDeleteCacheTTL,
    getAccounts: v1Api.dboAPIListAccounts,
    getCacheEfficiency: v1Api.dboAPIGetCacheEfficiency,
    getCacheGroupPerformanceMetrics: v1Api.dboAPIGetCacheGroupPerformance,
    getCacheGroupPerformanceSummary:
      v1Api.dboAPIGetCacheGroupPerformanceSummary,
    getCacheGroupOperationalMetrics:
      v1Api.dboAPIGetCacheGroupOperationalMetrics,
    getCacheGroupMetricsFilterOptions:
      v1Api.dboAPIGetCacheGroupMetricsFilterOptions,
    getCacheGroupPoolingEligibility:
      v1Api.dboAPIGetCacheGroupPoolingEligibility,
    getCacheGroups: v1Api.dboAPIListCacheGroups,
    getCacheGroup: v1Api.dboAPIGetCacheGroup,
    getCacheQueries: v1Api.dboAPIGetCacheQueries,
    getCacheQuery: v1Api.dboAPIGetCacheQuery,
    getCacheQueryTemplate: v1Api.dboAPIGetCacheQueryTemplate,
    getCacheQueryInsights: v1Api.dboAPIGetCacheQueryInsights,
    getCachingRules: v1Api.dboAPIListCacheTTLs,
    getCachingSummary: v1Api.dboAPIGetCacheSummary,
    getCluster: v1Api.dboAPIGetDatabaseCluster,
    getComponents: v1Api.dboAPIListDatabaseComponents,
    getDbInstance: v1Api.dboAPIGetDatabaseInstance,
    getInfrastructureMetrics:
      v1Api.dboAPIGetDatabaseInstanceInfrastructureMetrics,
    getHealthMetrics:
      v2DatabaseInstancesApi.databaseInstancesAPIGetDatabaseInstanceHealthMetrics,
    updateCacheConfiguration: v1Api.dboAPIUpdateCacheConfiguration,
    deleteCacheConfiguration: v1Api.dboAPIDeleteCacheConfiguration,
    updateCacheGroup: v1Api.dboAPIUpdateCacheGroup,
    updateCachingRule: v1Api.dboAPIUpdateCacheTTL,
    deleteCacheGroup: v1Api.dboAPIDeleteCacheGroup,
    getPerformanceAdvisorCacheGroups:
      v2AdvisorApi.advisorAPIListAdvisorCacheGroups,
    getPerformanceAdvisorCacheGroup:
      v2AdvisorApi.advisorAPIGetAdvisorCacheGroup,
    getPerformanceAdvisorDatabases: v2AdvisorApi.advisorAPIListAdvisorDatabases,
    getPerformanceAdvisorRecommendations:
      v2AdvisorApi.advisorAPIListAdvisorRecommendations,
    getPerformanceAdvisorRecommendation:
      v2AdvisorApi.advisorAPIGetAdvisorRecommendationDetail,
    closePerformanceRecommendation:
      v2AdvisorApi.advisorAPICloseAdvisorRecommendation,
    reopenPerformanceRecommendation:
      v2AdvisorApi.advisorAPIReopenAdvisorRecommendation,
    createDatabaseInstance:
      v2DatabaseInstancesApi.databaseInstancesAPICreateDatabaseInstance,
    deleteDatabaseInstance:
      v2DatabaseInstancesApi.databaseInstancesAPIDeleteDatabaseInstance,
    getDatabaseInstances:
      v2DatabaseInstancesApi.databaseInstancesAPIListDatabaseInstances,
    getDatabaseInstanceDetails:
      v2DatabaseInstancesApi.databaseInstancesAPIGetDatabaseInstanceDetails,
    getDatabaseInstanceCachingSummary:
      v2DatabaseInstancesApi.databaseInstancesAPIGetDatabaseInstanceCachingSummary,
    getDatabaseInstanceMetricsFilterOptions:
      v2DatabaseInstancesApi.databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions,
    getCloudSyncStatus:
      v2DatabaseInstancesApi.databaseInstancesAPIGetCloudSyncStatus,
    getCloudIntegrationSummary:
      v2DatabaseInstancesApi.databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary,
    listCloudOptimizationCandidates:
      v2DatabaseInstancesApi.databaseInstancesAPIListCloudOptimizationCandidates,
    listTopQueryRecommendations:
      v2DatabaseInstancesApi.databaseInstancesAPIListTopQueryRecommendations,
    listCachingPotentialDatabases:
      v2DatabaseInstancesApi.databaseInstancesAPIListCachingPotentialDatabases,
    listConnectionPoolingCandidates:
      v2DatabaseInstancesApi.databaseInstancesAPIListConnectionPoolingCandidates,
    updateDatabaseInstance:
      v2DatabaseInstancesApi.databaseInstancesAPIUpdateDatabaseInstance,
    createDatabase: v2DatabaseInstancesApi.databaseInstancesAPICreateDatabase,
    deleteDatabase: v2DatabaseInstancesApi.databaseInstancesAPIDeleteDatabase,
    createProxy: v2CachingApi.cachingAPICreateProxy,
    updateProxyDatabase: v2CachingApi.cachingAPIUpdateProxyDatabase,
    getDatabaseCachingSummary: v2CachingApi.cachingAPIGetProxyCacheSummary,
    getDatabaseCacheEfficiency: v2CachingApi.cachingAPIGetProxyCacheMetrics,
    getProxyQueriesV2: v2CachingApi.cachingAPIGetProxyQueries,
    getProxyCacheSummary: v2CachingApi.cachingAPIGetProxyCacheSummary,
    getCacheQueryInsightsV2: v2CachingApi.cachingAPIGetProxyCacheQueryInsights,
    getProxyCacheQueryTemplate:
      v2CachingApi.cachingAPIGetProxyCacheQueryTemplate,
    getInstanceProxyCacheMetrics:
      v2CachingApi.cachingAPIGetInstanceProxyCacheMetrics,
    listCacheRules: v2CachingApi.cachingAPIListCacheRules,
    createCacheRule: v2CachingApi.cachingAPICreateCacheRule,
    updateCacheRule: v2CachingApi.cachingAPIUpdateCacheRule,
    deleteCacheRule: v2CachingApi.cachingAPIDeleteCacheRule,
    getProxyConnectionsMetrics:
      v2CachingApi.cachingAPIGetProxyConnectionsMetrics,
    getProxyPerformanceMetrics:
      v2CachingApi.cachingAPIGetProxyPerformanceMetrics,
    getInstanceTelemetry:
      v2TelemetryApi.telemetryAPIListDatabaseInstancesTelemetry,
  };
};
